import { 
	GET_PROJECT_DRAWINGS, 
	GET_PROJECT_DRAWING,
	CREATE_PROJECT_DRAWING,
	UPDATE_PROJECT_DRAWING,
	DESTROY_PROJECT_DRAWING,
} from "./actions"

export function ProjectDrawingsReducer(state = {}, action) {
	switch (action.type) {
		case `${GET_PROJECT_DRAWINGS}_FULFILLED`:{
			return _.mapKeys(action.payload.data, "id");
		}
		case `${GET_PROJECT_DRAWING}_FULFILLED`:
		case `${CREATE_PROJECT_DRAWING}_FULFILLED`:
		case `${UPDATE_PROJECT_DRAWING}_FULFILLED`:{
			let newState = _.clone(state);
			const newItem = action.payload.data;
			const id = _.get(newItem,"id")
			newState[id] = newItem
			return newState;
		}		
		case `${DESTROY_PROJECT_DRAWING}_FULFILLED`:{
			let newState = _.clone(state);
			const deletedItem = action.payload.data;
			const id = _.get(deletedItem,"id")
			newState = _.filter(newState,i => i.id != id)
			return newState;
		}
		default:
			return state;
	}
}

// Move this to the reducer page
// import { ProjectDrawingsReducer } from "modules/project/drawings/reducer"

// project_drawings:ProjectDrawingsReducer,
